<template>
    <div class="popup__overlay" id="popupContainer">
        <div class="campaign__popup" id="popupHolder">
            <div>
                <!-- Header with status -->
                <div class="popup__header">
                  <div class="popup__header-info">
                    <p>{{ campaign.name }} Campaign Stats</p>
                    <span v-if="campaign.status" :class="[campaign.status === 'approved' ? campaign.active === 'Y' ? campaign.status + '__status' : 'declined__status' : campaign.status + '__status']">{{ campaign.status === 'approved' ? campaign.active === 'Y' ? 'ACTIVE' : 'INACTIVE' : campaign.status.toUpperCase() }}</span>
                  </div>
                  <!-- Controll buttons -->
                  <div class="control-btn-container popup__header-actions">
                    <div class="btn" @click="toggleCampaignStatus" :class="{'disabled-btn': activeUpdate}">
                        <clip-loader color="#2EA3FF" size="15px" :loading="activeUpdate" />
                        <p style="display: block;">{{ campaign.active === "Y" ? 'Deactivate' : 'Activate' }}</p>
                    </div>
                    <div class="btn">
                        <div class="delete--btn" @click="deletePrompt=!deletePrompt">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                            </svg>
                            <p>Delete Campaign</p>
                        </div>
                        <div class="btn-popup" v-if="deletePrompt">
                            <p>Are you sure?</p>
                            <div class="option-btn" @click="deleteCampaign">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <div class="option-btn" @click="deletePrompt=false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="btn" @click="editCampaign">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
                            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                        <p>Edit Campaign</p>
                    </div>
                    <div class="btn" @click="$emit('closePopup')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </div>
                  </div>
                </div>

                <!-- Top boxes -->
                <div class="boxes__container">
                    <div class="box__container box-shadow">
                        <img src="./../../assets/active_driver.svg" />
                        <p class="label">Active Drivers</p>
                        <p class="value">{{ campaign.active_drivers }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/total_drivers.svg" />
                        <p class="label">Total Drivers</p>
                        <p class="value">{{ campaign.total_drivers }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/impressions.svg" />
                        <p class="label">Impressions</p>
                        <p class="value">{{ campaign.impressions }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/impressions.svg" />
                        <p class="label">Real time impressions</p>
                        <p class="value">{{ campaign.RT_impressions }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/display_count.svg" style="width: 60px;"/>
                        <p class="label">Display Count</p>
                        <p class="value">{{ campaign.show_count }}</p>
                    </div>
                    <div class="box__container box-shadow">
                        <img src="./../../assets/cost.svg" style="width: 45px;"/>
                        <p class="label">Cost</p>
                        <p class="value">{{ campaign.spent }}</p>
                    </div>
                </div>

                <!-- Overview -->
                <div class="campaign__overview box-shadow">
                    <p class="overview__header">OVERVIEW OF CAMPAIGN</p>
                      <div class="campaign_left">
                        <video
                            v-if="isVideoContent(campaign.content_url)"
                            :src="campaign.content_url"
                            controls
                            playsinline
                            preload="metadata"
                        ></video>
                        <img v-else :src="campaign.content_url"/>
                     </div>
                    <div class="campaign__top__row">
                        <div class="campaign__pair">
                            <p class="label">TOTAL BUDGET</p>
                            <p class="value" v-if="campaignReport.info">${{ campaignReport.info[0].budget }}</p>
                        </div>
                        <div class="campaign__pair">
                            <p class="label">DEVICE GROUP</p>
                            <p class="value">{{campaign.device_group || '-'}}</p>
                        </div>
                        <div class="campaign__pair">
                            <p class="label">CAR TYPE</p>
                            <p class="value">{{carTypes}}</p>
                        </div>


                    </div>
                    <div class="campaign__bottom__row">
                        <p class="label">SCHEDULE</p>
                        <div class="campaign__pair__holder">
                            <div class="campaign__pair">
                                <p>Start date: {{ customUSFormatter(campaign.start_date) }}</p>
                                <p>End date: {{ customUSFormatter(campaign.end_date) }}</p>
                            </div>
                            <div class="campaign__pair">
                                <p>Start time: {{ calculateTime(campaign.start_time) }}</p>
                                <p>End time: {{ calculateTime(campaign.end_time) }}</p>
                            </div>
                             <div class="campaign__pair">
                                <p class="label">CYCLE DURATION</p>
                                <p class="value" v-if="campaign.duration">{{ campaign.duration }}</p>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Brief report -->
                <div class="box-shadow">
                    <p class="charts__header">Brief report</p>
                    <div class="charts__row">
                        <div class="chart__container">
                            <div class="chart">
                                <apexchart type="line" :options="dayChartOptions" :series="dayChartSeries" style="width: 100%"></apexchart>
                            </div>
                            <p>Impression distribution per day</p>
                        </div>
                        <div class="chart__container">
                            <div class="chart">
                                <apexchart type="line" :options="hourChartOptions" :series="hourChartSeries" style="width: 100%"></apexchart>
                            </div>
                            <p>Impression distribution per hour</p>
                        </div>
                    </div>
                    <div class="report-btn" @click="downloadReport">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Download Full Report
                </div><br/><br/><br/>
                </div>

                <!-- Maps -->
                <div class="maps__container box-shadow" style="display: flex">
                    <GmapMap
                        v-show="campaign.lat"
                        :center="{lat: campaign.lat, lng: campaign.lon}"
                        :zoom="10"
                        ref="geofenceMap"
                        :options="{mapTypeControl: false, streetViewControl: false, styles, zoomControl: false, fullscreenControl: true, gestureHandling: 'cooperative'}"
                        map-type-id="terrain"
                        style="width: 50%; margin: 15px; height: 300px"
                    >
                        <GmapCircle
                            ref="theCircle"
                            v-if="campaign.ZIP_codes && campaign.ZIP_codes.length === 0"
                            :center="{lat: campaign.lat, lng: campaign.lon}"
                            :radius="campaign.distance"
                            :clickable="false"
                            :draggable="false"
                            :editable="false"
                            :options="{strokeColor: '#102130', strokeWeight: 2, fillColor: 'rgb(223, 242, 255)', fillOpacity: .5}"
                        />
                        <GmapPolygon v-for="(polygon, index) in computedPolygons"  :key="index" v-bind:path.sync="polygon" v-bind:options="{strokeColor: '#102130', strokeWeight: 2, fillColor: 'rgb(223, 242, 255)', fillOpacity: .5}"></GmapPolygon>
                    </GmapMap>

                    <heatmap
                      v-if="campaignHeatMapPoints"
                      class="campaign-heatmap"
                      :initialPoints="campaignHeatMapPoints"
                      :center="{lat: campaign.lat, lng: campaign.lon}"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import styles from '@utils/mapStylesDark.js'
import Chart from '@utils/Chart.js'
import {gmapApi} from 'vue2-google-maps'
import toast from '@utils/toast'
import $ from 'jquery'
import { mapGetters } from 'vuex'
import store from "@store"

import Heatmap from './Heatmap.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

const mapType = 'terrain'
const googleMapOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  styles,
  zoomControl: false,
  fullscreenControl: true,
  gestureHandling: 'cooperative',
}

export default {
  name: 'CampaignPopup',
  components: {
    ClipLoader,
    Heatmap
  },
  googleMapOptions,
  mapType,
  data () {
    return {
        store,
        deletePrompt: false,
        path: [
            { lat: 55.9352001, lng: -4.7766924 },
            { lat: 55.9358131, lng: -4.7770143 },
            { lat: 55.9361256, lng: -4.7767353 },
            { lat: 55.9366784, lng: -4.7739458 }
        ],
        showInfo: false,
        infoWIndowContext: {
            position: {
                lat: 44.2899,
                lng: 11.8774
            }
        },
        infoWindowsList: [],
        styles,
        hourChartOptions: {},
        dayChartOptions: {},
        hourChartSeries: [],
        dayChartSeries: [],
        statsCoordinates: [],
        geofenceMap: null,
        zipcodeMap: null,
        polygons: [],
        bounds: null,
        activeUpdate: false,
        heatmapLayer: null,
        campaign: {},
        campaignStats: {},
        campaignReport: {},
        value: '',
        zoomRestarts: 0,
        categorieName: '',
        carTypes: '',

        campaignHeatMapPoints: null,
    }
  },
  methods: {
    toggleInfoWindow (context) {
        this.infoWIndowContext = context
        this.showInfo = true
    },
    infoClicked (context) {
    },
    setDayChart () {
        let categories = []
        let series = []
        this.campaignReport.displays_by_weekday.map(obj=>{
            categories.push(obj.day)
            series.push(obj.RT_impressions)
        })

        this.dayChartOptions = Chart.getChartOptions("day-chart-categories", categories)
        this.dayChartSeries = Chart.getChartSeries("day-chart-series", series)
    },
    setHourChart () {
        let categories = []
        let series = []

        this.campaignReport.displays_by_hour.map(obj=>{
            // let hour = this.setHourValue(obj.hour)
            categories.push(obj.hour)
            series.push(obj.duration)
        })

        if(this.isMobile()){
            newCategories = categories.filter(function(value, index, categories) {
                return index % 3 == 0;
            });
            this.hourChartOptions = Chart.getChartOptions("hour-chart-categories", newCategories, true)
        } else {
            this.hourChartOptions = Chart.getChartOptions("hour-chart-categories", categories)
        }

        this.hourChartSeries = Chart.getChartSeries("hour-chart-series", series)
    },
    setHourValue (hour) {
        if(hour === 0){
            return "12am"
        } else if (hour === 12) {
            return "12pm"
        } else if(hour > 12) {
            return (hour - 12) + "pm"
        } else {
            return hour + "am"
        }
    },
    isVideoContent (url) {
        return /\.(mp4|mov|webm|ogg|ogv|m4v)(\?.*)?$/i.test(url || '')
    },
    deleteCampaign () {
        let url = '/delete/campaign'
        let body = {
            data: {
                campaign_id: this.campaign.id
            }
        }
        this.request(url, 'POST', body).then(response=>{
            if(response.result === "success"){
                this.$emit('onDelete')
                toast.campaignDeleted()
            } else {
                toast.failedInsert()
            }
        })
    },
    toggleCampaignStatus () {
        if(!this.activeUpdate){
            let url = '/set/campaign'
            let active = this.campaign.active === "Y" ? "N" : "Y";
            this.activeUpdate = true
            let json = {
                data: {...this.campaign, campaign_id: this.campaign.id, active},
                API_KEY: this.store.getters.keys.api_key,
                code: this.token.token,
                user: this.user.user
            }

            this.request(url, 'POST', json).then((response)=>{
                if (response.code === 0) {
                    this.activeUpdate = false
                    this.campaign.active = active;
                    toast.successMessage("Status updated successfully")
                } else {
                    toast.successMessage(response.message)
                    if (response.code === 112) {

                    }
                }
            }).catch(err=>{
                this.activeUpdate = false
                toast.errorMessage("Something went wrong")
            })
        }
    },
    editCampaign () {
        this.$emit('closePopup')
        this.$router.push({name: 'EditCampaign', params: {id: this.campaign.id}})
    },
    extractCoordinates (coordinates, loop=false) {
        if(!loop){
            this.polygons = []
            this.bounds = new this.google.maps.LatLngBounds()
        }

        if(typeof coordinates[0][0] === "number") {
            var polygon = []
            coordinates.map(pair=>{
                let latLng = new this.google.maps.LatLng(pair[1], pair[0])
                this.bounds.extend(latLng)
                polygon.push({ lat: pair[1], lng: pair[0] })
            })
            this.polygons.push(polygon)
        } else {
            coordinates.map(pair=>{
                this.extractCoordinates(pair, true)
            })
        }
    },
    zoomCircle () {
        let self = this;

        let interval = setInterval(() => {
            try{
                if(self.$refs.theCircle && self.$refs.theCircle.$circleObject){
                    self.geofenceMap.fitBounds(self.$refs.theCircle.$circleObject.getBounds())
                    clearInterval(interval)
                }
            } catch (error) {
                // if (this.zoomRestarts < 10) {
                //     setTimeout(() => {
                //         this.zoomRestarts++
                //         this.zoomCircle()
                //     }, 2000)
                // }
            }
        }, 50)
    },
        downloadReport () {
            print($("#popupContainer"))
        },

    fetchCampaignStats() {
      const url = '/get/campaign/stats'
      const body = {
        data: {
          campaign_id: this.campaignID,
        }
      }

      return this.request(url, 'POST', body)
    },

    setCampaignStats() {
      this.fetchCampaignStats().then(response => {
        let heatMap = response.data.points
        if (Object.keys(heatMap).length !== 0) {
          this.campaignHeatMapPoints = heatMap
        } else {
          this.campaignHeatMapPoints = []
        }
      })
    },

    setCampaignReport() {
        var url = '/get/campaign/report'
        var body = {
            data: {
                campaign_id: this.campaignID
            }
        }

        this.request(url, 'POST', body).then(response=>{
            this.campaignReport = response.data[0]
            this.setDayChart()
            this.setHourChart()
        })
    },
    setMap() {
        this.polygons = []
        if(this.campaign && this.campaign.ZIP_codes && this.campaign.ZIP_codes.length > 0){
            let self = this
            var url = '/get/ZIP_codes'
            var body = {
                data: { zip_codes: this.campaign.ZIP_codes }
            }

            this.request(url, 'POST', body).then(response=>{

                this.polygons = []
                if(response.data.boundary === null || response.data.zip_codes.length === 0){
                    return
                }
                let coordinates = response.data.boundary.coordinates;

                this.extractCoordinates(coordinates)
                let self = this

                let geofenceInterval = setInterval(() => {
                    if(self.geofenceMap){
                        self.geofenceMap.fitBounds(self.bounds)
                        clearInterval(geofenceInterval)
                    }
                }, 50)
            })
        } else {
            this.zoomCircle()
        }
    },
    setCampaign () {
        var url = '/get/campaign'
        var body = {
            data: {
                campaign_id: this.campaignID
            }
        }

        this.request(url, 'POST', body).then(response=>{
            this.campaign = response.data[0]
            console.log(this.campaign)
            this.categorieName = this.setCategories(this.campaign.category)
            this.carTypes = this.setCarType(this.campaign.car_types)
            this.setMap()
        })
    },
    setCategories (categorieIndex) {
        var categoriesList = this.schema.categories
        for (let index = 0 ; index < categoriesList.length ; index++) {
            if (categoriesList[index].id === categorieIndex) {
                return categoriesList[index].name
            }
        }
    },
    setCarType (car_type) {
        let string = ''
        var carType = this.schema.car_types
        for (let index = 0 ; index < carType.length ; index++) {
            if (car_type.includes(carType[index].id)) {
			    string += carType[index].type + '; '
            }
        }
        return string
    },
    calculateTime (time) {
        if (time !== undefined) {
            var splitTime = time.split(':')
            var first = parseInt(splitTime[0])
            if (first > 12) {
                first -= 12
                return `${first}:${splitTime[1]} PM`
            }
            return `${first}:${splitTime[1]} AM`
        }
    }

  },
  props: {
      campaignID: {
            type: Number,
            default: 0
      }
  },
  mounted () {
        var self = this;
        this.setCampaign()
        this.setCampaignReport()
        this.setCampaignStats()

        this.$refs['geofenceMap'].$mapPromise.then((map) => {
            self.geofenceMap = map
        })

        setTimeout(() => {
            var mapElement = document.getElementsByClassName("vue-map-container")
            mapElement[0].setAttribute("style", "width: 50%; margin: 15px; height: 301px;")
        }, 800)

  },
  computed: {
    google: gmapApi,
    computedPolygons: function() {
        if(this.polygons.length > 0){
            return this.polygons
        } else {
            return []
        }
    },
    ...mapGetters({
        user: 'getUser',
        token: 'getToken',
        schema: 'getSchema'
    })
  },
}
</script>

<style scoped>
.v-spinner {
    margin-right: 10px;
}

.disabled-btn{
    background: rgb(229, 229, 229);
    border: none;
    cursor: not-allowed;
}

.popup__overlay{
    width: 100%;
    height: 100%;
    z-index: 99;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: show__popup;
    animation-duration: .3s;
    animation-fill-mode: forwards;
}

@keyframes show__popup{
    0%{
        opacity: 0;
        transform: scale(0);
    }

    100%{
        opacity: 1;
        transform: scale(1);
    }
}

.campaign__popup{
    position: relative;
    width: 100%;
    margin: 15px;
    height: 100%;
    z-index: 99;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 15px;
    overflow-y: auto;
}
.control-btn-container .btn{
    color: #000;
    border-radius: 5px;
    display: flex;
    align-items: center;
    border: 1px solid #000;
    padding: 5px;
    margin: 5px;
    font-size: 14px;
    position: relative;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.control-btn-container .btn p{
    padding: 0;
    margin: 0;
}

.control-btn-container .btn:hover{
    color: #2EA3FF;
    border: 1px solid #2EA3FF;
    cursor: pointer;
}

.control-btn-container .btn:hover .option-btn svg{
    color: #000;
}

.delete--btn{
    display: flex;
    align-items: center;
}

.control-btn-container .btn .btn-popup{
    position: absolute;
    top: 100%;
    border-radius: 5px;
    background: #fff;
    padding: 5px;
    right: 0px;
    border: 1px solid #000;
    margin-top: 5px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    align-items: center;
}

.control-btn-container .btn .btn-popup p{
    margin: 0 20px 0 5px;
    padding: 0;
    min-width: 100px;
}

.control-btn-container .btn .btn-popup .option-btn{
    border: 1px solid #000;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.control-btn-container .btn .btn-popup .option-btn svg{
    width: 14px;
    height: 14px;
    margin-right: 0;
}

.control-btn-container .btn .btn-popup .option-btn:hover{
    border: 1px solid #2EA3FF;
}

.control-btn-container .btn .btn-popup .option-btn:hover svg{
    color: #2EA3FF;
}

.control-btn-container .btn svg{
    margin-right: 5px;
}

.control-btn-container .btn:last-of-type{
    margin-right: 0;
}

.control-btn-container .btn:last-of-type svg{
    margin-right: 0;
}

.popup__header{
    text-align: left;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    box-sizing: border-box;
}

.popup__header p{
    font-size: 16px;
}

.popup__header span{
    background: #42DDA1;
    border-radius: 12px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    padding: 5px 10px 5px 10px;
    margin-left: 20px;
    height: 12px;
    display: flex;
    align-items: center;
}

.campaign__overview{
    min-height:  100px;
    padding: 15px;
    margin-top: 25px;
    margin-bottom: 25px;
}

.campaign__top__row{
    display: flex;
    margin-top: 15px;
}

.campaign__bottom__row{
    text-align: left;
}

.campaign_left{
    float:left;
    max-width:30%;
    width:30%;
    height:160px;
    margin-right: 3%;
 }
 .campaign_left img,
 .campaign_left video{
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding:10px 0;
    margin-top:-2%;
 }
.campaign__bottom__row .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 10px;
}

.campaign__bottom__row .campaign__pair__holder{
    display: flex;
}

.campaign__bottom__row .campaign__pair{
    margin-right: 15px;
}

.campaign__bottom__row .campaign__pair p{
    text-align: left;
    font-size: 14px;
}

.campaign__top__row .campaign__pair{
    min-width: 28%;
}
.campaign__bottom__row .campaign__pair{
    min-width: 26%;
}

.campaign__top__row .campaign__pair .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
}

.campaign__top__row .campaign__pair .value{
    font-size: 14px;
    font-weight: normal;
    text-align: left;
}

.box-shadow{
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(15, 32, 47, 0.5);
}

.boxes__container{
    display: flex;
}

.box__container{
    flex-grow: 1;
    flex-basis: 80px;
    height: 125px;
    margin: 0 10px 10px 10px;
    text-align: left;
    padding: 0 15px 15px 15px;
}

.box__container img{
    width: 35px;
    height: 60px;
}

.box__container .label{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
}

.box__container .value{
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 20px;
    margin-top: 15px;
}

.box__container:nth-of-type(1){
    margin-left: 0;
}

.box__container:nth-of-type(6){
    margin-right: 0;
}

.overview__header{
    margin: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
}

.charts__row{
    display: flex;
}

.chart__container{
    margin: 15px;
    width: 50%;
}

.chart{
    box-shadow: 0px 0px 15px rgba(181, 181, 181, 0.412);
    border-radius: 15px;
}

.chart__container p{
    text-align: left;
    font-size: 14px;
    text-transform: uppercase;
}

.charts__header{
    margin: 15px 15px 0 15px;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-align: left;
    padding-top: 15px;
}

.maps__container{
    margin-top: 25px;
    margin-bottom: 25px;
}

.report-btn{
    float:right;
     margin-right:15px;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 8px;
    color: #000;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.report-btn:hover{
    color: #2EA3FF;
    border: 1px solid #2EA3FF;
    cursor: pointer;
}

.report-btn svg{
    margin-right: 5px;
    height: 14px;
    width: 14px;
}

p{
    color: #000;
}

.campaign-heatmap {
  width: 50%;
  margin: 15px;
  height: 300px;
}

@media only screen and (max-width: 600px) {
    .btn p{
        display: none;
    }

    .control-btn-container .btn svg{
        margin-right: 0;
    }

    .popup__header p {
        font-size: 12px;
    }

    .boxes__container {
        flex-wrap: wrap;
    }

    .box__container {
        margin-left: 0;
    }

    .box__container:nth-of-type(even){
        margin-right: 0;
    }

    .campaign__top__row {
        flex-wrap: wrap;
    }

    .campaign__top__row .campaign__pair {
        margin-right: 15px;
    }

    .charts__row {
        flex-direction: column;
    }

    .chart__container {
        width: calc(100% - 30px);
        padding: 2px;
    }

    .chart__container .chart{
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .chart__container p {
        font-size: 12px;
    }

    .maps__container{
        flex-direction: column;
    }

    .vue-map-container{
        width: calc(100% - 30px) !important;
    }

}

@media only screen and (max-width: 1200px) {
.apx{
    transform-origin: left;
    transform: scale(0.5);
}
}
@media screen and (max-width: 1060px) and (min-width:600px) {
      .control-btn-container{
        margin-top: -2%;
      }
      .popup__header{
        margin-top: 5%;
      }
    }
</style>
